<template>
  <!-- 档次/计划表单 -->
  <Modal v-model="visible" :title="title" :footer-hide="true" :mask-closable="false" width="600" class="my-modal min">
    <Form class="page-form" ref="myForm" :model="formData" :label-width="70">
      <FormItem prop="gradeCode" label="编号" :rules="gradeCodeRule" class="full">
        <Input v-model.trim="formData.gradeCode" :disabled="editType == 'edit'" />
      </FormItem>
      <FormItem prop="name" label="名称" :rules="$units.formRule.required('请输入名称')" class="full">
        <Input v-model="formData.name" />
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save" :loading="loading">提交</Button>
    </div>
  </Modal>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {},
  props: {
    productCode: null,
    additionals: null,
    gradeAdditions: null
  },
  data() {
    return {
      title: '',
      editType: '',
      formData: {
        gradeCode: '',
        name: ''
      },
      gradeCodeRule: [
        {
          required: true,
          message: '请输入档次/计划编号',
          trigger: 'change'
        },
        {
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入档次/计划编号'));
            } else {
              const code = this.formData.gradeCode;
              console.log(code, this.additionals, this.gradeAdditions);
              if (this.gradeAdditions && this.gradeAdditions.length) {
                // 检测当前附加险code是否与其余重复
                let lth = this.gradeAdditions.filter(i => i.gradeCode == code).length;
                let idx = this.gradeAdditions.findIndex(i => i.gradeCode == code);
                if (
                  (this.editType == 'add' && lth != 0) ||
                  (this.editType == 'edit' && (lth > 1 || (idx != -1 && idx != this.selIndex)))
                ) {
                  callback(new Error('档次/计划已存在此编码，请重新录入'));
                }
              }
              if (this.additionals && this.additionals.length) {
                let lth = this.additionals.filter(i => i.addCode == code).length;
                if (lth) {
                  callback(new Error('产品code已存在，请重新录入'));
                }
              }
              callback();
            }
          },
          trigger: 'blur'
        }
      ],
      visible: false,
      loading: false,
      selIndex: ''
    };
  },
  methods: {
    open(row = {}, editType, index) {
      this.loading = false;
      this.title = editType == 'add' ? '新增档次/计划' : '编辑档次/计划';
      this.editType = editType;
      this.selIndex = index;
      this.formData = JSON.parse(JSON.stringify(row));
      this.clearValidate();
      this.visible = true;
    },
    save() {
      this.$refs.myForm.validate().then(isok => {
        if (!isok) {
          return;
        }
        if (this.formData.gradeCode == '00') {
          this.$notice.error('00编号不可用');
          return;
        }
        if (this.editType == 'add') {
          this.gradeAdditions.push(this.formData);
          this.$notice.success('新增成功');
        } else {
          this.$set(this.gradeAdditions, this.selIndex, this.formData);
          this.$notice.success('修改成功');
        }
        this.visible = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  /deep/ {
    .ivu-checkbox-inner {
      top: -1px;
    }

    .ivu-checkbox-group-item {
      width: 25%;
      margin-right: 0;
    }
  }
}

.tab-box {
  position: relative;
  margin-bottom: 10px;

  .tab-name {
    position: absolute;
    left: 0;
    top: 11px;
    z-index: 1;
    font-size: 14px;
    font-weight: bold;
  }

  /deep/ {
    .ivu-tabs-nav {
      padding-left: 120px;
    }
  }
}
</style>
